














































































































































































































































import { Mixins, Component, Prop, Watch } from 'vue-property-decorator';
import { AxPage } from '@/mixins';

import * as U from '@/utils';
import * as I from '@/interfaces';

class State {
  passWord: string;
  repassWord: string;
  constructor() {
    this.passWord = '' as never;
    this.repassWord = '' as never;
  }
}

@Component
export default class AxMealProcessingDialog extends Mixins(AxPage) {
  // 날짜 Start
  zoneCode = 0;

  dates = [];
  date = U.formatTime(new Date().toISOString(), 'YYYY-MM-DD');

  beginDate = U.formatTime(new Date().toISOString(), 'YYYY-MM-DD');
  beginDateMenu = false;
  endDate = U.formatTime(new Date().toISOString(), 'YYYY-MM-DD');
  endDateMenu = false;

  beginTime = '00:00';
  beginTimeMenu = false;
  endTime = '23:59';
  endTimeMenu = false;

  async prepare() {
    this.zoneCode = this.getZoneList()[0]?.code || 0;
  }

  get dateRangeText() {
    return this.dates.sort().join(' ~ ');
  }
  // 날짜 End

  // Dialog Start
  on = true;

  state = new State();

  @Prop({ default: () => new I.DataParam() })
  param!: I.DataParam;

  @Prop({ type: String, default: '500px' })
  width!: string;

  @Prop({ type: String, default: '350px' })
  height!: string;

  @Watch('on')
  onSwitchChanged() {
    this.$emit('changed', this.on);
  }

  async makeMealCollectPacket(): Promise<I.PacketMealCollect | undefined> {
    const fromDatetime = `${this.beginDate}T00:00:00.000Z`;
    const toDatetime = `${this.beginDate}T23:59:00.000Z`;

    return {
      zoneCode: this.zoneCode,
      fromDatetime: fromDatetime,
      toDatetime: toDatetime
    };
  }

  async onCollectClicked() {
    const packet = await this.makeMealCollectPacket();
    if (!packet) return;

    console.log('collect', packet);

    this.setLoading(true);
    const result = await this.API.call.meal.mealEventCollect(packet);
    this.setLoading(false);

    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      await this.showErrorModal('정보', '식수처리 되었습니다.');
      return result;
    }
  }

  // Dialog End
}
